import styled from 'styled-components';

export const FileInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;

  label {
    background-color: #007bff;
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #0056b3;
    }
  }

  input {
    display: none;
  }

  span {
    margin-top: 0.5rem;
    color: gray;
    font-size: 0.9rem;
  }
`;
